export default {
    ADD_RAW_MATERIAL(state, rawMaterial) {
      state.rawMaterials.unshift(rawMaterial);
      state.totalDataRow++;
    },
    SET_RAW_MATERIALS(state, res) {
      state.rawMaterials = res.items
      state.totalDataRow = res.totalCount;
    },
    UPDATE_RAW_MATERIAL(state, rawMaterial) {
      const rawMaterialIndex = state.rawMaterials.findIndex((p) => p.id == rawMaterial.id)
      Object.assign(state.rawMaterials[rawMaterialIndex], rawMaterial)
    },
    REMOVE_RAW_MATERIAL(state, rawMaterialId) {
      const rawMaterialIndex = state.rawMaterials.findIndex((p) => p.id == rawMaterialId)
      state.rawMaterials.splice(rawMaterialIndex, 1)
    },
  }
  